import { RingFinishEnum } from '@jouzen/ecom-components/v3/enums/ringFinish';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import CompareJadeOR4Modal from '@/app/components/CompareModelsModal/CompareJadeOR4Modal';
import RichText from '@/app/components/RichText';
import usePathnameWithoutLocale from '@/app/hooks/usePathnameWithoutLocale';

const NotSureCompareRingsSection = () => {
  const t = useTranslations();
  const pathname = usePathnameWithoutLocale();

  const jadeCeramicSwatchData = [
    {
      id: RingFinishEnum.Midnight,
      finish: t('midnight'),
      swatchSrc: 'jade/jade_midnight_swatch.png',
    },
    {
      id: RingFinishEnum.Tide,
      finish: t('tide'),
      swatchSrc: 'jade/jade_tide_swatch.png',
    },
    {
      id: RingFinishEnum.Cloud,
      finish: t('cloud'),
      swatchSrc: 'jade/jade_cloud_swatch.png',
    },
    {
      id: RingFinishEnum.Petal,
      finish: t('petal'),
      swatchSrc: 'jade/jade_petal_swatch.png',
    },
  ];

  const or4SwatchData = [
    {
      id: RingFinishEnum.Silver,
      finish: t('product_catalog_color_silver'),
      swatchSrc: 'hardware-pdp/finish-selector/silver.png',
    },
    {
      id: RingFinishEnum.Black,
      finish: t('product_catalog_color_black'),
      swatchSrc: 'hardware-pdp/finish-selector/black.png',
    },
    {
      id: RingFinishEnum.Stealth,
      finish: t('product_catalog_color_stealth'),
      swatchSrc: 'hardware-pdp/finish-selector/stealth.png',
    },
    {
      id: RingFinishEnum.BrushedSilver,
      finish: t('product_catalog_color_brushed_silver'),
      swatchSrc: 'hardware-pdp/finish-selector/brushed-silver.png',
    },
    {
      id: RingFinishEnum.Gold,
      finish: t('product_catalog_color_gold'),
      swatchSrc: 'hardware-pdp/finish-selector/gold.png',
    },
    {
      id: RingFinishEnum.RoseGold,
      finish: t('product_catalog_color_rosegold'),
      swatchSrc: 'hardware-pdp/finish-selector/rose-gold.png',
    },
  ];

  const onTriggerButtonClick = () => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'compare rings',
      location: 'body',
      path: pathname,
      action: 'open comparison modal',
    });
  };

  return (
    <section
      className="flex flex-col items-center justify-center py-10 md:py-20"
      data-cy="not-sure-compare-rings-section"
    >
      <Typography
        Element="h2"
        align="center"
        height="tight"
        font="serif"
        className="text-[2rem] leading-[1.1] md:text-[3rem] lg:text-[4rem] xl:text-[5rem]"
      >
        <RichText messageKey="not_sure_which_compare_title" />
      </Typography>
      <CompareJadeOR4Modal
        or4SwatchData={or4SwatchData}
        jadeCeramicSwatchData={jadeCeramicSwatchData}
        onTriggerButtonClick={onTriggerButtonClick}
      />
    </section>
  );
};

export default NotSureCompareRingsSection;
